import { allTrackers } from "app/services/track/track";

import createAIAgentTrackingService from "./factory";

const AIAgentTrackingService = createAIAgentTrackingService(allTrackers.dispatchTrackEvent.bind(allTrackers));

export default AIAgentTrackingService;
